import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  heading: {
    id: 'views.InfoAboutCompany.heading',
    defaultMessage: 'Rynek i działalność spółki'
  }
});



// WEBPACK FOOTER //
// ./src/views/InfoAboutCompany/InfoAboutCompanyView.intl.js